import { shopwareApiClient } from '$lib/api/shopwareApi.js';
import type { ApiRequestParams } from '$lib/api/shopwareApi.js';
import type { ApiReturnType } from '$lib/api/shopwareApi.js';
import type { ShopContext } from '$lib/context.js';

export class ContextApi {
    public static getSalutations(
        shopContext: ShopContext,
        fetchImplementation?: typeof fetch
    ): Promise<ApiReturnType<'readSalutation'>> {
        return shopwareApiClient.invoke(
            'readSalutation post /salutation',
            {},
            {
                fetchImplementation,
                shopContext
            }
        );
    }

    public static getCountries(
        shopContext: ShopContext,
        fetchImplementation?: typeof fetch
    ): Promise<ApiReturnType<'readCountry'>> {
        return shopwareApiClient.invoke(
            'readCountry post /country',
            {},
            {
                fetchImplementation,
                shopContext
            }
        );
    }

    public static getPaymentMethods(
        shopContext: ShopContext,
        fetchImplementation?: typeof fetch
    ): Promise<ApiReturnType<'readPaymentMethod'>> {
        return shopwareApiClient.invoke(
            'readPaymentMethod post /payment-method',
            {},
            {
                fetchImplementation,
                shopContext
            }
        );
    }

    public static getShippingMethods(
        shopContext: ShopContext,
        fetchImplementation?: typeof fetch
    ): Promise<ApiReturnType<'readShippingMethod'>> {
        return shopwareApiClient.invoke(
            'readShippingMethod post /shipping-method?onlyAvailable',
            {},
            {
                fetchImplementation,
                shopContext
            }
        );
    }

    public static updateContext(
        data: ApiRequestParams<'updateContext'>,
        shopContext: ShopContext,
        fetchImplementation?: typeof fetch
    ): Promise<ApiReturnType<'updateContext'>> {
        return shopwareApiClient.invoke('updateContext patch /context', data, {
            fetchImplementation,
            shopContext
        });
    }

    public static logoutCustomer(
        shopContext: ShopContext,
        fetchImplementation?: typeof fetch
    ): Promise<ApiReturnType<'logoutCustomer'>> {
        return shopwareApiClient.invoke(
            'logoutCustomer post /account/logout',
            {},
            {
                fetchImplementation,
                shopContext
            }
        );
    }
}
